export default "__VITE_PUBLIC_ASSET__9c7ca2fd__"